//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Conic.js";
import "../no/ugmath.js";
let d=[[[0,"EndAngle",0,0],[0,"MajorRadius",0,0],[0,"MinorRadius",0,0],[0,"StartAngle",0,0]],[[["majorRadius","minorRadius","startAngle","endAngle","rotationAngle","center"],"GetParams",{},0,0],[["major_radius","minor_radius","start_angle","end_angle","rotationAngle","center"],"SetParams",{},6,0]],[]];
SPLM.Ellipse = class extends SPLM.Conic{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Ellipse";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;